<template>
	<div class="container-fluid bg-white">
		<template v-if="!isGlobalTasks">
			<service-contract-toolbar :customer-name="customerName"></service-contract-toolbar>

			<h2>
				<template >
					Schedule of Values
					<br>
					<small v-if="$store.serviceContract" class="text-muted">Contract #{{$store.serviceContract.contract_num}}</small>
				</template>
			</h2>
		</template>

		<toolbar v-else>
			<h2>
				<i class="fa fa-hammer"></i>
				Service Tasks
			</h2>
			<projects-toolbar-controls 
				:is-services="true"
				:mobile-breakpoint="1000">
			</projects-toolbar-controls>
		</toolbar>

		<table-list
			record-name="Item"
			:fields="scheduleFields"
			:records="mutatedTasks"
			:has-delete="true"
			:has-edit="true"
			:rows-draggable="true"
			:has-drag-handle="true"
			v-on:edit="editScheduleItem"
			v-on:delete="deleteScheduleItem"
			v-on:dragEnd="reorderRows">

			<button class="btn btn-success mr-1" type="button" v-on:click="addNewScheduleItem">
				<i class="fa fa-plus"></i>
				Add Item
			</button>

			<button v-if="!importWidgetVisible" type="button" class="btn btn-light" v-on:click="importWidgetVisible = true">
				<i class="fa fa-upload"></i>
				Import Tasks
			</button>

			<widget v-if="importWidgetVisible" 
				class="mt-2"
				title="Import Tasks"
				header-button="fa-times" 
				v-on:headerButtonClick="importWidgetVisible = false">

				<h4>Fields:</h4>

				<ul>
					<li>Item Number</li>
					<li>Description</li>
					<li>Price</li>
					<li>Unit Cost</li>
				</ul>

				<input type="file" class="form-control mb-2" v-on:change="importCSV">

				<p><strong>Example:</strong></p>

				<table class="spreadsheet-table mb-3">
					<tr>
						<th></th>
						<th>A</th>
						<th>B</th>
						<th>C</th>
						<th>D</th>
					</tr>
					<tr>
						<th>1</th>
						<td>1.1</td>
						<td>Toilet Install</td>
						<td>35.50</td>
						<td>20.00</td>
					</tr>
					<tr>
						<th>2</th>
						<td>1.2</td>
						<td>Sink Install</td>
						<td>79.99</td>
						<td>25.00</td>
					</tr>
					<tr>
						<th>3</th>
						<td>1.3</td>
						<td>Tub/Shower Install</td>
						<td>199.00</td>
						<td>50.00</td>
					</tr>
				</table>

			</widget>

		</table-list>

		<modal-dialog
			:modal-visible="scheduleItemModal.visible"
			:title="scheduleItemModal.title"
			confirm-button-text="Save"
			v-on:confirm="saveItem"
			v-on:closeModal="scheduleItemModal.visible = false">

			<field label="Item Number" 
				col-class="col-sm-4" 
				
				v-model="scheduleItemModal.record.item_number">
			</field>

			<field label="Description" 
				col-class="col-sm-4" 
				
				v-model="scheduleItemModal.record.description">
			</field>

			<field label="Price" 
				col-class="col-sm-4" 
				:params="{type:'number',min:0,step:0.01}"
				v-model="scheduleItemModal.record.unit_price">
			</field>

			<field label="Internal Cost" 
				col-class="col-sm-4" 
				:params="{type:'number',min:0,step:0.01}"
				v-model="scheduleItemModal.record.unit_cost">
			</field>

		</modal-dialog>

	</div>
</template>
<script type="text/javascript">
import Field from "@/components/Field"
import TableList from "@/components/TableList"
import ModalDialog from "@/components/ModalDialog"
import Widget from "@/components/Widget"
import Toolbar from "@/layout_fragments/Toolbar"

import ServiceContractToolbar from "./ServiceContractToolbar"
import ProjectsToolbarControls from "@/pages/project/ProjectsToolbarControls"
import ServiceContractMixins from "@/mixins/ServiceContractMixins.js"

export default {
	name: "ServiceContractTasks",
	components: {
		ServiceContractToolbar,
		ProjectsToolbarControls,
		TableList,
		Field,
		ModalDialog,
		Widget,
		Toolbar
	},
	props: ["isGlobalTasks"],
	mixins: [ServiceContractMixins],
	data() {
		return {
			working: false,
			scheduleItemModal: {
				visible: false,
				title: "Add New Item",
				record: {},
				new: false
			},
			scheduleFields: [
				{label: "Item Number",key:"item_number"},
				{label: "Description",key:"description"},
				{label: "Unit Price",key:"unitPriceFormatted",align:"right"},
				{label: "Unit Cost",key:"unitCostFormatted",align:"right"}
			],
			globalTasks: [],
			deleteContractModalVisible: false,
			importWidgetVisible: false
		}
	},
	computed: {
		mutatedTasks() {
			let tasks = []
			if (this.isGlobalTasks) {
				tasks = this.globalTasks
			}
			else {
				if (this.$store.serviceContract && "ServiceContractTask" in this.$store.serviceContract && this.$store.serviceContract.ServiceContractTask)
					tasks = this.$store.serviceContract.ServiceContractTask
					
				else
					return []
			}

			return tasks.map(item => {
				item.sortHandle = "<i class='fa fa-sort'></i>"

				let price = +item.unit_price
				let cost = +item.unit_cost

				item.unitPriceFormatted = price.toCurrency()
				item.unitCostFormatted = cost.toCurrency()

				return item
			})
		}
	},
	methods: {
		editScheduleItem(record) {
			this.scheduleItemModal.visible = true
			this.scheduleItemModal.record = record
			this.scheduleItemModal.title = "Edit Item"
			this.scheduleItemModal.new = false
		},
		addNewScheduleItem() {
			this.scheduleItemModal.visible = true
			this.scheduleItemModal.record = {
				description: null,
				unit_price: null,
				item_number: null,
				unit_cost: null
			}
			this.scheduleItemModal.title = "Add New Item"
			this.scheduleItemModal.new = true
		},
		saveItem() {

			let vm = this

			this.scheduleItemModal.record.unit_price = parseFloat(this.scheduleItemModal.record.unit_price).toFixed(2)

			let payload = this.scheduleItemModal.record

			if (!this.isGlobalTasks)
				payload.contract_id = this.$store.serviceContract.id

			this.postData("ServiceContractTask/save",payload,true).then(response => {
				if (response.success) {
					vm.scheduleItemModal.visible = false

					vm.alertSaved("Item saved")

					vm.fetchTasks()
				}
				
			})
			
		},
		deleteScheduleItem(record) {
			let vm = this

			this.postData("ServiceContractTask/delete",{id: record.id},true).then(response => {
				vm.alertSuccess("Item deleted")
				vm.fetchTasks()
			})
		},
		reorderRows(event) {
			let movedItem = this.$store.serviceContract.ServiceContractTask.splice(event.oldIndex,1)
			//insert into new place
			this.$store.serviceContract.ServiceContractTask.splice(event.newIndex,0,movedItem[0])

			let vm = this

			let payload = {
				records: JSON.stringify(this.$store.serviceContract.ServiceContractTask.map((task,index) => {
					return {
						id: task.id,
						sort_order: index
					}
				}))
			}

			this.postData("ServiceContractTask/save-batch",payload)
		},
		importCSV(evt) {
			let files = evt.target.files; // FileList object
			let f = files[0];

			let vm = this

			let reader = new FileReader();

			let fileValid = true

			let allowedMimes = [
				"text/plain",
				"text/csv",
				"application/vnd.ms-excel"
			]

			//check file extension type
			if (allowedMimes.indexOf(f.type) == -1)
				vm.alertFail("Invalid file format! File must be a CSV")

			else {

				 // Closure to capture the file information.
				reader.onload = (theFile => {
					return e => {
						
						let csvObj = vm.CSVToArray(e.target.result)

						//check if last row is a blank, if so remove it
						if (csvObj[csvObj.length-1].length == 1)
							csvObj.splice(csvObj.length-1,1)

						let recordsPayload, numFields

						numFields = 4

						//check appropriate number of fields per row
						csvObj.forEach(row => {
							if (row.length != numFields)
								fileValid = false
						})

						if (fileValid) {

							recordsPayload = csvObj.map((row,index) => {
								let obj = {
									item_number: row[0],
									description: row[1],
									unit_price: row[2],
									unit_cost: row[3]
								}

								if (!vm.isGlobalTasks && vm.$store.serviceContract && vm.$store.serviceContract.id)
									obj.contract_id = vm.$store.serviceContract.id

								return obj
							})

							vm.postData("ServiceContractTask/save-batch",{records:JSON.stringify(recordsPayload)},true).then(response => {
								if (response.success) {
									vm.alertSuccess("Import success!")
									vm.fetchTasks()
									this.importWidgetVisible = false
								}
							})					
						}
						else 
							vm.alertFail("Invalid CSV format! There must be "+numFields+" fields per row.")
					};
				})(f);

				reader.readAsText(f);
			}
		},
		fetchTasks() {
			let vm = this

			let params = {}

			if (this.isGlobalTasks)
				params.filters = [["contract_id", 0]]
			else
				params.filters = [["contract_id", this.$store.serviceContract.id]]

			this.getJSON("ServiceContractTask/get",params).then(response => {
				if (response.success) {
					if (vm.isGlobalTasks)
						vm.globalTasks = response.data
					else
						vm.$store.serviceContract.ServiceContractTask = response.data
				}
			})
		}
	},
	created() {
		this.fetchContractIfNotSet(this.$route.params.slug)

		if (this.isGlobalTasks)
			this.fetchTasks()
	}
}
</script>